import React from 'react';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import { Icon, Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { ResultStatusIconProps } from './ResultStatusIcon.props';
import {
  COMPLETE,
  FAILED,
  PENDING,
  POLLING
} from '../../../../../../hooks/useRollingApiRequest/useRollingApiRequest.props';
import {STATUS} from '../../../../../../services/hooks/useRolloverCompanies/rollover.types';

const ResultStatusIcon = ({state, errorMsg}: ResultStatusIconProps) => (<Icon>
  {[PENDING, POLLING].includes(state) && <CircularProgress size={24} />}
  {state === COMPLETE && <CheckCircleOutline color="primary" />}
  {state === FAILED && (
    <Tooltip title={errorMsg ?? ''} disableHoverListener={!errorMsg}>
      <ErrorOutline color="error" />
    </Tooltip>
  )}
  {state === STATUS.CONFLICT && (
    <Tooltip title={errorMsg ?? ''} disableHoverListener={!errorMsg}>
      <CheckCircleOutline />
    </Tooltip>
  )}
</Icon>)

export default ResultStatusIcon;